import { initFederation } from '@angular-architects/native-federation';

const isLocalhost = window.location.origin.includes('localhost') || window.location.origin.includes('127.0.0.1');
const manifestUrl = `${document.baseURI}assets/federation.manifest${isLocalhost ? '.local' : ''}.json`;

// console.log('INIZIO MAIN.TS');
console.log(manifestUrl);
fetch(manifestUrl)
.then(res => res.json())
.then(manifest => {
  //console.log(' Manifest caricato correttamente', manifest);

  //  FIX: passiamo l'oggetto come `{ remotes: ... }`
  return initFederation(manifest);
})
.then(() => import('./bootstrap'))
.catch(err => {
  console.error('initFederation failed', err);
});